// @flow

class StickyCTA {
    el: HTMLElement;
    container: ?HTMLElement;
    counterpart: ?HTMLElement;
    observer: IntersectionObserver;
    containerVisible: boolean = false;
    counterpartVisible: boolean = false;

    static classes = {
        active: "active",
    };

    constructor(el: HTMLElement) {
        this.el = el;

        this.container = document.getElementById(
            el.getAttribute("data-sticky-cta-container") || ""
        );

        this.counterpart = document.getElementById(
            el.getAttribute("data-sticky-cta-counterpart") || ""
        );

        this.observer = new IntersectionObserver(this.handleObservation, {
            threshold: 0,
        });

        this.attachHandlers();
    }

    attachHandlers = () => {
        if (this.container) {
            this.observer.observe(this.container);
        }
        if (this.counterpart) {
            this.observer.observe(this.counterpart);
        }
    };

    handleObservation = (entries: Array<IntersectionObserverEntry>) => {
        entries.forEach((entry: IntersectionObserverEntry) => {
            if (entry.target === this.container) {
                this.containerVisible = entry.isIntersecting;
                this.render();
            } else if (entry.target === this.counterpart) {
                this.counterpartVisible = entry.isIntersecting;
                this.render();
            }
        });
    };

    render() {
        if (!this.counterpartVisible && this.containerVisible) {
            // Show it
            this.el.classList.add(StickyCTA.classes.active);
        } else {
            // Hide it
            this.el.classList.remove(StickyCTA.classes.active);
        }
    }
}

const els = document.querySelectorAll(".sticky-cta");
els.forEach((el: HTMLElement) => {
    new StickyCTA(el);
});
